import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Company } from '../../common/model/company';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private http: HttpClient) {}

  findAll(params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/u/companies`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findSelectItems(): Observable<any> {
    const url = `${environment.url.api}/a/companies/select-items`;
    return this.http
      .get<any>(url, { })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findOne(id: string): Observable<any> {
    const url = `${environment.url.api}/u/companies/${id}`;
    return this.http.get<Company>(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  create(company: Company): Observable<any> {
    const url = `${environment.url.api}/a/companies`;
    return this.http.post<Company>(url, company).pipe(timeout(environment.config.apiWaitingTime));
  }

  save(company: Company): Observable<any> {
    const url = `${environment.url.api}/a/companies/${company.id}`;
    return this.http.put<Company>(url, company).pipe(timeout(environment.config.apiWaitingTime));
  }

  delete(id: string): Observable<any> {
    const url = `${environment.url.api}/a/companies/${id}`;
    return this.http.delete<Company>(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  findSelection(): Observable<any> {
    const url = `${environment.url.api}/u/companies/menu/select`;
    return this.http.get(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  fetchSuggestions(params?: HttpParams): Observable<any> {
    const url = `${environment.url.api}/u/companies/search`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findAllUpdateById(id: string, params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/u/companies/${id}/updates`;
    return this.http
      .get(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }
}
